module.exports = __webpack_public_path__ + "img/nav_7.a4525605.png";